// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CopyrightCircleTwoToneSvg from "@ant-design/icons-svg/es/asn/CopyrightCircleTwoTone";
import AntdIcon from '../components/AntdIcon';

var CopyrightCircleTwoTone = function CopyrightCircleTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CopyrightCircleTwoToneSvg
  }));
};

CopyrightCircleTwoTone.displayName = 'CopyrightCircleTwoTone';
export default React.forwardRef(CopyrightCircleTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/CopyrightCircleTwoTone.js
// module id = 879
// module chunks = 0